import { Component, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/common/global_variables';
import { CreateComponent } from '@app/common/templates/create/create.component';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
	templateUrl: '../../../../common/templates/create/create.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/create/style.scss'],
	providers: [DialogService, MessageService, ConfirmationService]
})
export class TblFahrzeugAbwicklungAbschnittTypCreateComponent extends CreateComponent {
	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		@Optional() public config: DynamicDialogConfig,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public dialogService: DialogService,
		public globals: Globals,
		public messageService: MessageService,
		@Optional() public ref: DynamicDialogRef,
		public router: Router,
		public translate: TranslateService,
	) {
		super(accountService, breadcrumbService, config, confirmationService, crudService, dialogService, globals, messageService, ref, router, translate);

		this.apiUrl = 'TblFahrzeugAbwicklungAbschnittTyp';
		this.name = 'MENU.FAHRZEUG_ABWICKLUNG_ABSCHNITT_TYP';
		this.url = '/' + PATH.FAHRZEUG_ABWICKLUNG_ABSCHNITT_TYP;
		this.fieldgroups.push(
			[
				{ type: 'text', key: 'bezeichnung', required: true, width: 400 },
				{ type: 'text', key: 'bezeichnung_kurz', required: false, width: 400 },
			]
		);
		this.breadcrumbService.setItems([
			{ label: 'MENU.STAMMDATEN' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.CREATE', routerLink: [this.url + '/' + PATH.CREATE] }
		]);
	}

	/* override */
	getOptions(): void {
		super.getOptions();
		this.options.gruppe_id = [];
		this.loading += 1;
		this.crudService.getVehicleComponentTypeGroups().then(res => {
			if(res && res.length > 0) {
				const o = [];
				res.forEach(dataEntry => {
					o.push({
						label: dataEntry['Label'],
						value: dataEntry['Value']
					});
				});
				this.options.gruppe_id = o;
			}
		}).catch(() => {
			// no exception expected...
		}).finally(()=> {
			this.loading -= 1;
		})
	}
}
